



















import axios from "axios";
import { Vue, Component, Watch, Prop } from "vue-property-decorator";

@Component({})
export default class DocumentIndexPage extends Vue {
  private facts = [];

  private headers: object[] = [
    { text: "Document" },
    { text: "Figure", value: "figure" },
    { text: "Unit", value: "unit" },
    { text: "Term", value: "term" },
    { text: "Country", value: "country" },
    { text: "Excerpt", value: "excerpt" },
    { text: "Actions", value: "name", sortable: false },
  ];

  async created() {
    await this.load();
  }

  async load() {
    try {
      let response = await axios.get("/psql/parking_lot", {
        params: {
          type: "eq.facts",
          status: "eq.waiting",
        },
      });
      this.facts = response.data;
      this.$toast.success("Facts loaded");
    } catch (error) {
      console.error(error.response);
      this.$toast.error("Failed to load facts");
    }
  }

  // create() forward the users to prepopulated form (they may change their mind later)
  async create(id: number) {
    // if (!!id) {
    //   this.$router.push(`/scaffold/documents/parking_lot/${id}`);
    // }
  }

  // reject() rejects the document directly
  async reject(id: number) {
    // try {
    //   let response = await axios.post("/psql/rpc/helix_reject_parking_lot_record", {
    //     pl_id: id,
    //   });
    //   // remove from the dataset
    //   this.documents = this.documents.filter(
    //     (document: any) => document.id !== id
    //   );
    //   this.$toast.success("Document rejected");
    // } catch (error) {
    //   console.error(error.response);
    //   this.$toast.error("Failed to reject document");
    // }
  }
}
